var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnPrtChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 47.167,
    viewBox: "0 0 42 47.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "\\uD328\\uC2A4_4200",
    x: 0,
    y: 0,
    width: 42,
    height: 47.167,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "btn_prt_blu_com",
    transform: "translate(9 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_sh",
    transform: "translate(4 27)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    "data-name": "ic_sh",
    cx: 8.5,
    cy: 3,
    rx: 8.5,
    ry: 3,
    fill: "grey"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ic_prt_1-1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "point",
    "data-name": "\\uD328\\uC2A4 4200",
    d: "M12,0A12,12,0,0,1,24,12c0,6.627-12,17.167-12,17.167S0,18.627,0,12A12,12,0,0,1,12,0Z",
    transform: "translate(9 3)",
    fill: "#4976aa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "check",
    "data-name": "\\uD328\\uC2A4 4201",
    d: "M8.83,0A8.83,8.83,0,1,1,0,8.83,8.83,8.83,0,0,1,8.83,0Z",
    transform: "translate(3 3.17)",
    fill: "#67aaf8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "check-svgrepo-com",
    transform: "translate(6.5 -46.639)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "white",
    "data-name": "\\uD328\\uC2A4 4207",
    d: "M10.677,57.067l-5.8,5.8a1.1,1.1,0,0,1-1.557,0l-3-3a1.1,1.1,0,0,1,1.557-1.557L4.1,60.534,9.12,55.51a1.1,1.1,0,0,1,1.557,1.557Z",
    transform: "translate(0 0)",
    fill: "#FFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnPrtChecked);
export default __webpack_public_path__ + "static/media/btn_prt_checked.987bba99c964409e6125a139e6b0b6ec.svg";
export { ForwardRef as ReactComponent };